import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function LangToggle({ className = '' }) {
  const { lang, toggleLang, t } = useLanguage();
  return (
    <button
      type="button"
      className={`lang-toggle ${className}`.trim()}
      onClick={toggleLang}
      aria-label={`Switch to ${lang === 'en' ? 'Telugu' : 'English'}`}
    >
      {t('langToggle')}
    </button>
  );
}
